/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
 /* tslint:disable */

import * as import0 from './loading-indicator';
import * as import1 from '@angular/core/src/change_detection/change_detection';
import * as import2 from '@angular/core/src/linker/view_utils';
import * as import3 from '@angular/core/src/linker/view';
import * as import4 from '@angular/core/src/render/api';
import * as import5 from '@angular/core/src/linker/element';
import * as import6 from '@angular/core/src/di/injector';
import * as import7 from '@angular/core/src/linker/view_type';
import * as import8 from '@angular/core/src/metadata/view';
import * as import9 from '@angular/core/src/linker/component_factory';
import * as import10 from './assets/css/spinner.css.shim';
import * as import11 from '../../../node_modules/@angular/common/src/directives/ng_switch.ngfactory';
import * as import12 from '@angular/core/src/linker/template_ref';
import * as import13 from '@angular/common/src/directives/ng_switch';
import * as import14 from '../../../node_modules/@angular/common/src/directives/ng_style.ngfactory';
import * as import15 from '@angular/core/src/change_detection/differs/keyvalue_differs';
import * as import16 from '@angular/core/src/linker/element_ref';
import * as import17 from '@angular/common/src/directives/ng_style';
export class Wrapper_LoadingIndicator {
  context:import0.LoadingIndicator;
  changed:boolean;
  /*private*/ _expr_0:any;
  /*private*/ _expr_1:any;
  constructor() {
    this.changed = false;
    this.context = new import0.LoadingIndicator();
    this._expr_0 = import1.UNINITIALIZED;
    this._expr_1 = import1.UNINITIALIZED;
  }
  check_color(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import2.checkBinding(throwOnChange,this._expr_0,currValue))) {
      this.changed = true;
      this.context.color = currValue;
      this._expr_0 = currValue;
    }
  }
  check_type(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import2.checkBinding(throwOnChange,this._expr_1,currValue))) {
      this.changed = true;
      this.context.type = currValue;
      this._expr_1 = currValue;
    }
  }
  detectChangesInInputProps(view:import3.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this.changed;
    this.changed = false;
    return changed;
  }
  detectChangesInHostProps(view:import3.AppView<any>,el:any,throwOnChange:boolean):void {
  }
}
var renderType_LoadingIndicator_Host:import4.RenderComponentType = (null as any);
class _View_LoadingIndicator_Host0 extends import3.AppView<any> {
  _el_0:any;
  /*private*/ _appEl_0:import5.AppElement;
  _LoadingIndicator_0_4:Wrapper_LoadingIndicator;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_LoadingIndicator_Host0,renderType_LoadingIndicator_Host,import7.ViewType.HOST,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.selectOrCreateRenderHostElement(this.renderer,'loading-indicator',import2.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this._appEl_0 = new import5.AppElement(0,(null as any),this,this._el_0);
    var compView_0:any = viewFactory_LoadingIndicator0(this.viewUtils,this.injector(0),this._appEl_0);
    this._LoadingIndicator_0_4 = new Wrapper_LoadingIndicator();
    this._appEl_0.initComponent(this._LoadingIndicator_0_4.context,([] as any[]),compView_0);
    compView_0.create(this._LoadingIndicator_0_4.context,this.projectableNodes,(null as any));
    this.init(([] as any[]).concat([this._el_0]),[this._el_0],([] as any[]),([] as any[]));
    return this._appEl_0;
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.LoadingIndicator) && (0 === requestNodeIndex))) { return this._LoadingIndicator_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._LoadingIndicator_0_4.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._LoadingIndicator_0_4.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_LoadingIndicator_Host0(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  if ((renderType_LoadingIndicator_Host === (null as any))) { (renderType_LoadingIndicator_Host = viewUtils.createRenderComponentType('',0,import8.ViewEncapsulation.None,([] as any[]),{})); }
  return new _View_LoadingIndicator_Host0(viewUtils,parentInjector,declarationEl);
}
export const LoadingIndicatorNgFactory:import9.ComponentFactory<import0.LoadingIndicator> = new import9.ComponentFactory<import0.LoadingIndicator>('loading-indicator',viewFactory_LoadingIndicator_Host0,import0.LoadingIndicator);
const styles_LoadingIndicator:any[] = [import10.styles];
var renderType_LoadingIndicator:import4.RenderComponentType = (null as any);
class _View_LoadingIndicator0 extends import3.AppView<import0.LoadingIndicator> {
  _text_0:any;
  _el_1:any;
  _NgSwitch_1_3:import11.Wrapper_NgSwitch;
  _text_2:any;
  _anchor_3:any;
  /*private*/ _appEl_3:import5.AppElement;
  _TemplateRef_3_5:any;
  _NgSwitchCase_3_6:import11.Wrapper_NgSwitchCase;
  _text_4:any;
  _anchor_5:any;
  /*private*/ _appEl_5:import5.AppElement;
  _TemplateRef_5_5:any;
  _NgSwitchCase_5_6:import11.Wrapper_NgSwitchCase;
  _text_6:any;
  _text_7:any;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_LoadingIndicator0,renderType_LoadingIndicator,import7.ViewType.COMPONENT,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import5.AppElement {
    const parentRenderNode:any = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
    this._text_0 = this.renderer.createText(parentRenderNode,'\n        ',(null as any));
    this._el_1 = import2.createRenderElement(this.renderer,parentRenderNode,'div',import2.EMPTY_INLINE_ARRAY,(null as any));
    this._NgSwitch_1_3 = new import11.Wrapper_NgSwitch();
    this._text_2 = this.renderer.createText(this._el_1,'\n            ',(null as any));
    this._anchor_3 = this.renderer.createTemplateAnchor(this._el_1,(null as any));
    this._appEl_3 = new import5.AppElement(3,1,this,this._anchor_3);
    this._TemplateRef_3_5 = new import12.TemplateRef_(this._appEl_3,viewFactory_LoadingIndicator1);
    this._NgSwitchCase_3_6 = new import11.Wrapper_NgSwitchCase(this._appEl_3.vcRef,this._TemplateRef_3_5,this._NgSwitch_1_3.context);
    this._text_4 = this.renderer.createText(this._el_1,'\n            ',(null as any));
    this._anchor_5 = this.renderer.createTemplateAnchor(this._el_1,(null as any));
    this._appEl_5 = new import5.AppElement(5,1,this,this._anchor_5);
    this._TemplateRef_5_5 = new import12.TemplateRef_(this._appEl_5,viewFactory_LoadingIndicator2);
    this._NgSwitchCase_5_6 = new import11.Wrapper_NgSwitchCase(this._appEl_5.vcRef,this._TemplateRef_5_5,this._NgSwitch_1_3.context);
    this._text_6 = this.renderer.createText(this._el_1,'\n        ',(null as any));
    this._text_7 = this.renderer.createText(parentRenderNode,'\n        ',(null as any));
    this.init(([] as any[]),[
      this._text_0,
      this._el_1,
      this._text_2,
      this._anchor_3,
      this._text_4,
      this._anchor_5,
      this._text_6,
      this._text_7
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import12.TemplateRef) && (3 === requestNodeIndex))) { return this._TemplateRef_3_5; }
    if (((token === import13.NgSwitchCase) && (3 === requestNodeIndex))) { return this._NgSwitchCase_3_6.context; }
    if (((token === import12.TemplateRef) && (5 === requestNodeIndex))) { return this._TemplateRef_5_5; }
    if (((token === import13.NgSwitchCase) && (5 === requestNodeIndex))) { return this._NgSwitchCase_5_6.context; }
    if (((token === import13.NgSwitch) && ((1 <= requestNodeIndex) && (requestNodeIndex <= 6)))) { return this._NgSwitch_1_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_1_0_0:any = this.context.type;
    this._NgSwitch_1_3.check_ngSwitch(currVal_1_0_0,throwOnChange,false);
    this._NgSwitch_1_3.detectChangesInInputProps(this,this._el_1,throwOnChange);
    const currVal_3_0_0:any = 'spinner';
    this._NgSwitchCase_3_6.check_ngSwitchCase(currVal_3_0_0,throwOnChange,false);
    this._NgSwitchCase_3_6.detectChangesInInputProps(this,this._anchor_3,throwOnChange);
    const currVal_5_0_0:any = 'cube';
    this._NgSwitchCase_5_6.check_ngSwitchCase(currVal_5_0_0,throwOnChange,false);
    this._NgSwitchCase_5_6.detectChangesInInputProps(this,this._anchor_5,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._NgSwitch_1_3.detectChangesInHostProps(this,this._el_1,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
export function viewFactory_LoadingIndicator0(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<import0.LoadingIndicator> {
  if ((renderType_LoadingIndicator === (null as any))) { (renderType_LoadingIndicator = viewUtils.createRenderComponentType('',0,import8.ViewEncapsulation.Emulated,styles_LoadingIndicator,{})); }
  return new _View_LoadingIndicator0(viewUtils,parentInjector,declarationEl);
}
class _View_LoadingIndicator1 extends import3.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _NgStyle_2_3:import14.Wrapper_NgStyle;
  _text_3:any;
  _el_4:any;
  _NgStyle_4_3:import14.Wrapper_NgStyle;
  _text_5:any;
  _el_6:any;
  _NgStyle_6_3:import14.Wrapper_NgStyle;
  _text_7:any;
  _el_8:any;
  _NgStyle_8_3:import14.Wrapper_NgStyle;
  _text_9:any;
  _el_10:any;
  _NgStyle_10_3:import14.Wrapper_NgStyle;
  _text_11:any;
  _map_17:any;
  _map_18:any;
  _map_19:any;
  _map_20:any;
  _map_21:any;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_LoadingIndicator1,renderType_LoadingIndicator,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
    this._map_17 = import2.pureProxy1((p0:any):{[key: string]:any} => {
      return {'background-color': p0};
    });
    this._map_18 = import2.pureProxy1((p0:any):{[key: string]:any} => {
      return {'background-color': p0};
    });
    this._map_19 = import2.pureProxy1((p0:any):{[key: string]:any} => {
      return {'background-color': p0};
    });
    this._map_20 = import2.pureProxy1((p0:any):{[key: string]:any} => {
      return {'background-color': p0};
    });
    this._map_21 = import2.pureProxy1((p0:any):{[key: string]:any} => {
      return {'background-color': p0};
    });
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.createRenderElement(this.renderer,(null as any),'div',new import2.InlineArray2(2,'class','spinner'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._el_2 = import2.createRenderElement(this.renderer,this._el_0,'div',new import2.InlineArray2(2,'class','rect1'),(null as any));
    this._NgStyle_2_3 = new import14.Wrapper_NgStyle(this.parent.parentInjector.get(import15.KeyValueDiffers),new import16.ElementRef(this._el_2),this.renderer);
    this._text_3 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._el_4 = import2.createRenderElement(this.renderer,this._el_0,'div',new import2.InlineArray2(2,'class','rect2'),(null as any));
    this._NgStyle_4_3 = new import14.Wrapper_NgStyle(this.parent.parentInjector.get(import15.KeyValueDiffers),new import16.ElementRef(this._el_4),this.renderer);
    this._text_5 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._el_6 = import2.createRenderElement(this.renderer,this._el_0,'div',new import2.InlineArray2(2,'class','rect3'),(null as any));
    this._NgStyle_6_3 = new import14.Wrapper_NgStyle(this.parent.parentInjector.get(import15.KeyValueDiffers),new import16.ElementRef(this._el_6),this.renderer);
    this._text_7 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._el_8 = import2.createRenderElement(this.renderer,this._el_0,'div',new import2.InlineArray2(2,'class','rect4'),(null as any));
    this._NgStyle_8_3 = new import14.Wrapper_NgStyle(this.parent.parentInjector.get(import15.KeyValueDiffers),new import16.ElementRef(this._el_8),this.renderer);
    this._text_9 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._el_10 = import2.createRenderElement(this.renderer,this._el_0,'div',new import2.InlineArray2(2,'class','rect5'),(null as any));
    this._NgStyle_10_3 = new import14.Wrapper_NgStyle(this.parent.parentInjector.get(import15.KeyValueDiffers),new import16.ElementRef(this._el_10),this.renderer);
    this._text_11 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._el_10,
      this._text_11
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import17.NgStyle) && (2 === requestNodeIndex))) { return this._NgStyle_2_3.context; }
    if (((token === import17.NgStyle) && (4 === requestNodeIndex))) { return this._NgStyle_4_3.context; }
    if (((token === import17.NgStyle) && (6 === requestNodeIndex))) { return this._NgStyle_6_3.context; }
    if (((token === import17.NgStyle) && (8 === requestNodeIndex))) { return this._NgStyle_8_3.context; }
    if (((token === import17.NgStyle) && (10 === requestNodeIndex))) { return this._NgStyle_10_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = this._map_17(this.parent.context.color);
    this._NgStyle_2_3.check_ngStyle(currVal_2_0_0,throwOnChange,false);
    this._NgStyle_2_3.detectChangesInInputProps(this,this._el_2,throwOnChange);
    const currVal_4_0_0:any = this._map_18(this.parent.context.color);
    this._NgStyle_4_3.check_ngStyle(currVal_4_0_0,throwOnChange,false);
    this._NgStyle_4_3.detectChangesInInputProps(this,this._el_4,throwOnChange);
    const currVal_6_0_0:any = this._map_19(this.parent.context.color);
    this._NgStyle_6_3.check_ngStyle(currVal_6_0_0,throwOnChange,false);
    this._NgStyle_6_3.detectChangesInInputProps(this,this._el_6,throwOnChange);
    const currVal_8_0_0:any = this._map_20(this.parent.context.color);
    this._NgStyle_8_3.check_ngStyle(currVal_8_0_0,throwOnChange,false);
    this._NgStyle_8_3.detectChangesInInputProps(this,this._el_8,throwOnChange);
    const currVal_10_0_0:any = this._map_21(this.parent.context.color);
    this._NgStyle_10_3.check_ngStyle(currVal_10_0_0,throwOnChange,false);
    this._NgStyle_10_3.detectChangesInInputProps(this,this._el_10,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._NgStyle_2_3.detectChangesInHostProps(this,this._el_2,throwOnChange);
    this._NgStyle_4_3.detectChangesInHostProps(this,this._el_4,throwOnChange);
    this._NgStyle_6_3.detectChangesInHostProps(this,this._el_6,throwOnChange);
    this._NgStyle_8_3.detectChangesInHostProps(this,this._el_8,throwOnChange);
    this._NgStyle_10_3.detectChangesInHostProps(this,this._el_10,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_LoadingIndicator1(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  return new _View_LoadingIndicator1(viewUtils,parentInjector,declarationEl);
}
class _View_LoadingIndicator2 extends import3.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _NgStyle_2_3:import14.Wrapper_NgStyle;
  _text_3:any;
  _el_4:any;
  _NgStyle_4_3:import14.Wrapper_NgStyle;
  _text_5:any;
  _el_6:any;
  _NgStyle_6_3:import14.Wrapper_NgStyle;
  _text_7:any;
  _el_8:any;
  _NgStyle_8_3:import14.Wrapper_NgStyle;
  _text_9:any;
  _el_10:any;
  _NgStyle_10_3:import14.Wrapper_NgStyle;
  _text_11:any;
  _el_12:any;
  _NgStyle_12_3:import14.Wrapper_NgStyle;
  _text_13:any;
  _el_14:any;
  _NgStyle_14_3:import14.Wrapper_NgStyle;
  _text_15:any;
  _el_16:any;
  _NgStyle_16_3:import14.Wrapper_NgStyle;
  _text_17:any;
  _el_18:any;
  _NgStyle_18_3:import14.Wrapper_NgStyle;
  _text_19:any;
  _map_29:any;
  _map_30:any;
  _map_31:any;
  _map_32:any;
  _map_33:any;
  _map_34:any;
  _map_35:any;
  _map_36:any;
  _map_37:any;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_LoadingIndicator2,renderType_LoadingIndicator,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
    this._map_29 = import2.pureProxy1((p0:any):{[key: string]:any} => {
      return {'background-color': p0};
    });
    this._map_30 = import2.pureProxy1((p0:any):{[key: string]:any} => {
      return {'background-color': p0};
    });
    this._map_31 = import2.pureProxy1((p0:any):{[key: string]:any} => {
      return {'background-color': p0};
    });
    this._map_32 = import2.pureProxy1((p0:any):{[key: string]:any} => {
      return {'background-color': p0};
    });
    this._map_33 = import2.pureProxy1((p0:any):{[key: string]:any} => {
      return {'background-color': p0};
    });
    this._map_34 = import2.pureProxy1((p0:any):{[key: string]:any} => {
      return {'background-color': p0};
    });
    this._map_35 = import2.pureProxy1((p0:any):{[key: string]:any} => {
      return {'background-color': p0};
    });
    this._map_36 = import2.pureProxy1((p0:any):{[key: string]:any} => {
      return {'background-color': p0};
    });
    this._map_37 = import2.pureProxy1((p0:any):{[key: string]:any} => {
      return {'background-color': p0};
    });
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.createRenderElement(this.renderer,(null as any),'div',new import2.InlineArray2(2,'class','sk-cube-grid'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._el_2 = import2.createRenderElement(this.renderer,this._el_0,'div',new import2.InlineArray2(2,'class','sk-cube sk-cube1'),(null as any));
    this._NgStyle_2_3 = new import14.Wrapper_NgStyle(this.parent.parentInjector.get(import15.KeyValueDiffers),new import16.ElementRef(this._el_2),this.renderer);
    this._text_3 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._el_4 = import2.createRenderElement(this.renderer,this._el_0,'div',new import2.InlineArray2(2,'class','sk-cube sk-cube2'),(null as any));
    this._NgStyle_4_3 = new import14.Wrapper_NgStyle(this.parent.parentInjector.get(import15.KeyValueDiffers),new import16.ElementRef(this._el_4),this.renderer);
    this._text_5 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._el_6 = import2.createRenderElement(this.renderer,this._el_0,'div',new import2.InlineArray2(2,'class','sk-cube sk-cube3'),(null as any));
    this._NgStyle_6_3 = new import14.Wrapper_NgStyle(this.parent.parentInjector.get(import15.KeyValueDiffers),new import16.ElementRef(this._el_6),this.renderer);
    this._text_7 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._el_8 = import2.createRenderElement(this.renderer,this._el_0,'div',new import2.InlineArray2(2,'class','sk-cube sk-cube4'),(null as any));
    this._NgStyle_8_3 = new import14.Wrapper_NgStyle(this.parent.parentInjector.get(import15.KeyValueDiffers),new import16.ElementRef(this._el_8),this.renderer);
    this._text_9 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._el_10 = import2.createRenderElement(this.renderer,this._el_0,'div',new import2.InlineArray2(2,'class','sk-cube sk-cube5'),(null as any));
    this._NgStyle_10_3 = new import14.Wrapper_NgStyle(this.parent.parentInjector.get(import15.KeyValueDiffers),new import16.ElementRef(this._el_10),this.renderer);
    this._text_11 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._el_12 = import2.createRenderElement(this.renderer,this._el_0,'div',new import2.InlineArray2(2,'class','sk-cube sk-cube6'),(null as any));
    this._NgStyle_12_3 = new import14.Wrapper_NgStyle(this.parent.parentInjector.get(import15.KeyValueDiffers),new import16.ElementRef(this._el_12),this.renderer);
    this._text_13 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._el_14 = import2.createRenderElement(this.renderer,this._el_0,'div',new import2.InlineArray2(2,'class','sk-cube sk-cube7'),(null as any));
    this._NgStyle_14_3 = new import14.Wrapper_NgStyle(this.parent.parentInjector.get(import15.KeyValueDiffers),new import16.ElementRef(this._el_14),this.renderer);
    this._text_15 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._el_16 = import2.createRenderElement(this.renderer,this._el_0,'div',new import2.InlineArray2(2,'class','sk-cube sk-cube8'),(null as any));
    this._NgStyle_16_3 = new import14.Wrapper_NgStyle(this.parent.parentInjector.get(import15.KeyValueDiffers),new import16.ElementRef(this._el_16),this.renderer);
    this._text_17 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._el_18 = import2.createRenderElement(this.renderer,this._el_0,'div',new import2.InlineArray2(2,'class','sk-cube sk-cube9'),(null as any));
    this._NgStyle_18_3 = new import14.Wrapper_NgStyle(this.parent.parentInjector.get(import15.KeyValueDiffers),new import16.ElementRef(this._el_18),this.renderer);
    this._text_19 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._el_10,
      this._text_11,
      this._el_12,
      this._text_13,
      this._el_14,
      this._text_15,
      this._el_16,
      this._text_17,
      this._el_18,
      this._text_19
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import17.NgStyle) && (2 === requestNodeIndex))) { return this._NgStyle_2_3.context; }
    if (((token === import17.NgStyle) && (4 === requestNodeIndex))) { return this._NgStyle_4_3.context; }
    if (((token === import17.NgStyle) && (6 === requestNodeIndex))) { return this._NgStyle_6_3.context; }
    if (((token === import17.NgStyle) && (8 === requestNodeIndex))) { return this._NgStyle_8_3.context; }
    if (((token === import17.NgStyle) && (10 === requestNodeIndex))) { return this._NgStyle_10_3.context; }
    if (((token === import17.NgStyle) && (12 === requestNodeIndex))) { return this._NgStyle_12_3.context; }
    if (((token === import17.NgStyle) && (14 === requestNodeIndex))) { return this._NgStyle_14_3.context; }
    if (((token === import17.NgStyle) && (16 === requestNodeIndex))) { return this._NgStyle_16_3.context; }
    if (((token === import17.NgStyle) && (18 === requestNodeIndex))) { return this._NgStyle_18_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = this._map_29(this.parent.context.color);
    this._NgStyle_2_3.check_ngStyle(currVal_2_0_0,throwOnChange,false);
    this._NgStyle_2_3.detectChangesInInputProps(this,this._el_2,throwOnChange);
    const currVal_4_0_0:any = this._map_30(this.parent.context.color);
    this._NgStyle_4_3.check_ngStyle(currVal_4_0_0,throwOnChange,false);
    this._NgStyle_4_3.detectChangesInInputProps(this,this._el_4,throwOnChange);
    const currVal_6_0_0:any = this._map_31(this.parent.context.color);
    this._NgStyle_6_3.check_ngStyle(currVal_6_0_0,throwOnChange,false);
    this._NgStyle_6_3.detectChangesInInputProps(this,this._el_6,throwOnChange);
    const currVal_8_0_0:any = this._map_32(this.parent.context.color);
    this._NgStyle_8_3.check_ngStyle(currVal_8_0_0,throwOnChange,false);
    this._NgStyle_8_3.detectChangesInInputProps(this,this._el_8,throwOnChange);
    const currVal_10_0_0:any = this._map_33(this.parent.context.color);
    this._NgStyle_10_3.check_ngStyle(currVal_10_0_0,throwOnChange,false);
    this._NgStyle_10_3.detectChangesInInputProps(this,this._el_10,throwOnChange);
    const currVal_12_0_0:any = this._map_34(this.parent.context.color);
    this._NgStyle_12_3.check_ngStyle(currVal_12_0_0,throwOnChange,false);
    this._NgStyle_12_3.detectChangesInInputProps(this,this._el_12,throwOnChange);
    const currVal_14_0_0:any = this._map_35(this.parent.context.color);
    this._NgStyle_14_3.check_ngStyle(currVal_14_0_0,throwOnChange,false);
    this._NgStyle_14_3.detectChangesInInputProps(this,this._el_14,throwOnChange);
    const currVal_16_0_0:any = this._map_36(this.parent.context.color);
    this._NgStyle_16_3.check_ngStyle(currVal_16_0_0,throwOnChange,false);
    this._NgStyle_16_3.detectChangesInInputProps(this,this._el_16,throwOnChange);
    const currVal_18_0_0:any = this._map_37(this.parent.context.color);
    this._NgStyle_18_3.check_ngStyle(currVal_18_0_0,throwOnChange,false);
    this._NgStyle_18_3.detectChangesInInputProps(this,this._el_18,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._NgStyle_2_3.detectChangesInHostProps(this,this._el_2,throwOnChange);
    this._NgStyle_4_3.detectChangesInHostProps(this,this._el_4,throwOnChange);
    this._NgStyle_6_3.detectChangesInHostProps(this,this._el_6,throwOnChange);
    this._NgStyle_8_3.detectChangesInHostProps(this,this._el_8,throwOnChange);
    this._NgStyle_10_3.detectChangesInHostProps(this,this._el_10,throwOnChange);
    this._NgStyle_12_3.detectChangesInHostProps(this,this._el_12,throwOnChange);
    this._NgStyle_14_3.detectChangesInHostProps(this,this._el_14,throwOnChange);
    this._NgStyle_16_3.detectChangesInHostProps(this,this._el_16,throwOnChange);
    this._NgStyle_18_3.detectChangesInHostProps(this,this._el_18,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_LoadingIndicator2(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  return new _View_LoadingIndicator2(viewUtils,parentInjector,declarationEl);
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/loading-indicator.ngfactory.ts